// type List = {
// 	title: string,
// 	description: string,
// 	count: number,
// 	createdDate: string,
// 	updatedDate: string,
// 	readOnly: boolean,
// 	shared: boolean,
// }

const listColumns = [
  {
    accessorKey: 'id'
  },
  {
    accessorKey: 'name'
  },
  {
    accessorKey: 'description'
  },
  {
    accessorKey: 'count'
  },
  {
    accessorKey: 'createdDate'
  },
  {
    accessorKey: 'updatedDate'
  },
  {
    accessorKey: 'shared'
  },
  {
    accessorKey: 'readOnly'
  }
]

export default listColumns